// extracted by mini-css-extract-plugin
export default {"root":"root--HkQ3z error-block","title":"title--hGgF9 error-block__title","text":"text--mpYYH"};